module.exports = __webpack_public_path__ + "assets/img/btn_chip_2.8ba2c394.png";